module.exports = __webpack_public_path__ + "static/img/logo-COLLINGWOOD.d8b821a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-COLLINGWOOD.svg
// module id = pkpY
// module chunks = 1